import generateCacheName from "../generateCacheName";
import { product } from "../../global/storefront/fragments";

const generateGroupQuery = (name) => {
  const cacheName = generateCacheName(name);

  return `  ${cacheName}: products(first: 50, query: "tag:'${name}'") {
    edges {
      node {
        ${product}
      }
    }
  }`;
};

const generateProductQuery = (name) => {
  const cacheName = generateCacheName(name);

  return `${cacheName}: product(id: "${name}") {
    ${product}
    family: metafield(namespace: "custom", key: "product_family_boost_search") {
      references(first: 50) {
        edges {
          node {
            ... on Product {
              ${product}
            }
          }
        }
      }
    }
  }`;
};

export default function generateGroupsQuery(groupItems) {
  const uniqueItems = groupItems.reduce((prev, curr) => {
    prev[curr.name] = curr.name;
    return prev;
  }, {});

  return `query getProductGroup @inContext(country: ${window.Shopify.country}){
  ${Object.keys(uniqueItems)
    .map((name) => {
      if (/^gid:\/\/shopify\/Product/.test(name)) {
        return generateProductQuery(name);
      }

      return generateGroupQuery(name);
    })
    .join("\n")}
}`;
}
